module.exports = __webpack_public_path__ + "img/shoulder-wfh-stretches.7777f37a.jpg";